// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import VerificationOutlinedSvg from "@fishx/icons-svg/es/asn/VerificationOutlined";
import FishxIcon from '../components/FishxIcon';

var VerificationOutlined = function VerificationOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: VerificationOutlinedSvg
  }));
};

VerificationOutlined.displayName = 'VerificationOutlined';
export default React.forwardRef(VerificationOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/VerificationOutlined.js
// module id = 4353
// module chunks = 0